import { Component, OnInit } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppError } from '../core/errors/http-error/app-error';
import { BuildingBorderQuery } from '../geometrics-form/building-borders/state/building-border.query';
import { BuildingQuery } from '../geometrics-form/buildings/state/building.query';
import { EdgeQuery } from '../geometrics-form/edges/state/edge.query';
import { VertexQuery } from '../geometrics-form/vertexes/state/vertex.query';
import { LoadingService } from '../shared/components/loading/loading.service';
import { Project } from './state/project.model';
import { ProjectQuery } from './state/project.query';
import { ProjectService } from './state/project.service';

@Component({
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit {

  projects$: Observable<Project[]>;
  project: Project;

  isLoading$ = this.loadingService.isLoading$;
  error: AppError;

  constructor(
    private projectService: ProjectService,
    private loadingService: LoadingService,
    projectQuery: ProjectQuery,
    vertexQuery: VertexQuery,
    edgeQuery: EdgeQuery,
    buildingQuery: BuildingQuery,
    buildingBorderQuery: BuildingBorderQuery
  ) {
    this.loadingService.loader(projectQuery.isLoading$);
    this.loadingService.loader(vertexQuery.isLoading$);
    this.loadingService.loader(edgeQuery.isLoading$);
    this.loadingService.loader(buildingQuery.isLoading$);
    this.loadingService.loader(buildingBorderQuery.isLoading$);
  }

  ngOnInit(): void {
    this.projects$ = this.projectService.get()
      .pipe(catchError(error => {
        this.error = error;
        return throwError(error);
      }));
  }
}
